if (!customElements.get('variant-selects')) {
  customElements.define(
    'variant-selects',
    class VariantSelects extends HTMLElement {
      constructor() {
        super();
      }

      get selectedOptionValues() {
        return Array.from(this.querySelectorAll('select option[selected], fieldset input:checked')).map(
          ({ dataset }) => dataset.optionValueId
        );
      }

      get selectedOptionMainValues() {
        return Array.from(
          this.querySelectorAll('select option[selected], fieldset input:checked')
        ).map(el => el.value || el.textContent.trim());
      }

      getPreOrderText(variantId) {
        return preOrderData[String(variantId)] || null;
      }

      getInputForEventTarget(target) {
        return target.tagName === 'SELECT' ? target.selectedOptions[0] : target;
      }

      connectedCallback() {
        this.addEventListener('change', (event) => {
          const target = this.getInputForEventTarget(event.target);
          this.updateSelectedSwatchValue(event);


          var productVariants_json = document.querySelector('.product-inventory-data').getAttribute('data-product-json');
          var productVariants = JSON.parse(productVariants_json);


          var preorderIDs = document.querySelector('.product__inventory.main-pre').getAttribute('data-pre-ids');
          var MainSubmitButton = document.querySelector('.main-product .main-product-form .product-form__submit span');
          var MainSubmitButton_normal_txt = MainSubmitButton.getAttribute('data-main-text');
          var MainSubmitButton_pre_txt = MainSubmitButton.getAttribute('data-other-text');

          let is_pre_order = false;
          let is_out_of_stock = false;
          let is_normal = false;

        
            const matchedVariant = productVariants.find(variant => {
              return JSON.stringify(variant.options) === JSON.stringify(this.selectedOptionMainValues);
            });
          

            document.querySelectorAll('.product__inventory').forEach(function(el) {
                el.classList.remove('active');
            });

            if(matchedVariant != undefined){

            // console.log(matchedVariant);
            // console.log(matchedVariant.available);

              if(!matchedVariant.available){
                is_out_of_stock = true;
              }else{
                if (preorderIDs.includes(matchedVariant.id)) {
                  is_pre_order = true;
                } else {
                  is_normal = true;
                }
              }

              // console.log(is_pre_order);
              // console.log(is_normal);

              const MainDiv = document.querySelector('.product__inventory.main-default');
              if (MainDiv && is_normal) {
                MainDiv.classList.add('active');  
              }

              const MainOutDiv = document.querySelector('.product__inventory.main-out-of-stock');
              if (MainOutDiv && is_out_of_stock) {
                MainOutDiv.classList.add('active');  
              }

              const MainPreDiv = document.querySelector('.product__inventory.main-pre');
              if (MainPreDiv && is_pre_order) {
                MainPreDiv.classList.add('active'); 
                var get_new_text_pre = this.getPreOrderText(matchedVariant.id);

                const inventoryText = MainPreDiv.querySelector('.product__inventory-text');
                inventoryText.innerHTML = `${get_new_text_pre.main_text}<span class="black-text">${get_new_text_pre.sub_text}</span>`;
              }

              if(is_pre_order && MainSubmitButton_pre_txt != ""){
                MainSubmitButton.classList.add('custom-btn-text');
                MainSubmitButton.style.setProperty('--text-var', `"${MainSubmitButton_pre_txt}"`);
              }else{
                MainSubmitButton.style.setProperty('--text-var', `"${MainSubmitButton_normal_txt}"`);
              }
            }else{
              const MainUnavailableDiv = document.querySelector('.product__inventory.main-unavailable');
              if (MainUnavailableDiv) {
                MainUnavailableDiv.classList.add('active');  
              }
               MainSubmitButton.style.setProperty('--text-var', '"IKKE TILGÆNGELIG"');
            }


             var get_option_id = this.selectedOptionValues;
             var mainElement = document.querySelector('.main-product').getAttribute('data-product-id');

           if(mainElement == "14787059188037" || mainElement == "14888695529797" || mainElement == "9713446650181" || mainElement == "9706041934149"){
              const body_main = document.querySelector('body');

              if(get_option_id[0] == '8684662522181' || get_option_id[0] == '8961646690629' || get_option_id[0] == '4370513199429' || get_option_id[1] == '4369919902021' || get_option_id[1] == '8684662554949'){
                   body_main.classList.add('show-outlet');
              }else{
                  body_main.classList.remove('show-outlet'); 
              }

              // console.log(get_option_id[1]);
            }

          FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.optionValueSelectionChange, {
            data: {
              event,
              target,
              selectedOptionValues: this.selectedOptionValues,
            },
          });
        });
      }

      updateSelectedSwatchValue({ target }) {
        const { value, tagName } = target;

        if (tagName === 'SELECT' && target.selectedOptions.length) {
          Array.from(target.options)
            .find((option) => option.getAttribute('selected'))
            .removeAttribute('selected');
          target.selectedOptions[0].setAttribute('selected', 'selected');

          const swatchValue = target.selectedOptions[0].dataset.optionSwatchValue;
          const selectedDropdownSwatchValue = target
            .closest('.product-form__input')
            .querySelector('[data-selected-value] > .swatch');
          if (!selectedDropdownSwatchValue) return;
          if (swatchValue) {
            selectedDropdownSwatchValue.style.setProperty('--swatch--background', swatchValue);
            selectedDropdownSwatchValue.classList.remove('swatch--unavailable');
          } else {
            selectedDropdownSwatchValue.style.setProperty('--swatch--background', 'unset');
            selectedDropdownSwatchValue.classList.add('swatch--unavailable');
          }

          selectedDropdownSwatchValue.style.setProperty(
            '--swatch-focal-point',
            target.selectedOptions[0].dataset.optionSwatchFocalPoint || 'unset'
          );
        } else if (tagName === 'INPUT' && target.type === 'radio') {
          const selectedSwatchValue = target.closest(`.product-form__input`).querySelector('[data-selected-value]');
          if (selectedSwatchValue) selectedSwatchValue.innerHTML = value;
        }
      }
    }
  );
}


// just for outlet page remove after sale end
document.addEventListener('page:loaded', function() {
  var mainElement_on_load = document.querySelector('.main-product').getAttribute('data-product-id');
  if(mainElement_on_load == "14787059188037"){
       var mainElement_var_id = document.querySelector('.product-variant-id').getAttribute('value');
      const body_main = document.querySelector('body');
      if(mainElement_var_id == '53645290799429' ){
           body_main.classList.add('show-outlet');
      }
    }
})